import React from 'react';
import './styles.css';

/**
 * TextReportWidget Component
 * 
 * Renders text/report responses in a formatted view
 * - Displays text responses in formatted view
 * - Preserves line breaks and formatting
 * - Optional markdown rendering support (future enhancement)
 * 
 * @param {Object} props
 * @param {Object} props.data - Response data
 * @param {string} props.data.response - Text content to display
 * @param {string} props.data.sheetTitle - Optional title for the report
 * @param {Function} props.onComplete - Callback when rendering is complete
 */
const TextReportWidget = ({ data, onComplete }) => {
    React.useEffect(() => {
        if (onComplete && data && data.response) {
            // Return the text response directly for backward compatibility
            onComplete(data.response);
        }
    }, [data, onComplete]);

    if (!data || !data.response) {
        return (
            <div className="archie-widget-error">
                No text data available to display
            </div>
        );
    }

    const title = data.sheetTitle || 'Report';
    const content = data.response;

    return (
        <div className="csv-data-outer">
            <div className="text-report-container">
                <h2>{title}</h2>
                <div style={{ whiteSpace: 'pre-wrap' }}>
                    {content}
                </div>
            </div>
        </div>
    );
};

export default TextReportWidget;
